import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';
import {z} from 'zod';

export const CohortAppConnectedPropertiesSchema = z.object({
  appId: z.string(),
  connectionId: z.string().uuid(),
});
export type CohortAppConnectedProperties = z.infer<typeof CohortAppConnectedPropertiesSchema>;

export type CohortAppConnectedEventStruct = UserEventStruct<
  'cohort.app.connected',
  CohortAppConnectedProperties
>;

export const CohortAppConnectedEventSpec: UserEventSpec<CohortAppConnectedEventStruct> = {
  id: 'cohort.app.connected',
  propertiesSchema: CohortAppConnectedPropertiesSchema,
};
